import { makePipelinesFetchKey } from './cacheKeys';
import { fetchPipelines } from './pipelines';
import { wrapPromise } from 'persist-promise/wrapPromise';
export const pipelinesPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'pipelines',
  deepFreeze: true,
  toCacheKey: makePipelinesFetchKey,
  fetch: fetchPipelines
});